import React from 'react';
import { useNavigate } from 'react-router-dom';

export const AccountDeleted: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#4A6651] to-[#598D76] flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-8 text-center">
        <div className="mb-6">
          <svg className="w-20 h-20 text-green-500 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>

        <h1 className="text-3xl font-bold text-gray-900 mb-4">Account Deleted</h1>
        
        <p className="text-gray-600 mb-8">
          Your account and all associated data have been permanently deleted.
        </p>

        <div className="bg-gray-50 rounded-lg p-4 mb-8">
          <p className="text-sm text-gray-700">
            We&apos;re sorry to see you go! If you ever want to come back, you&apos;re always welcome to create a new account.
          </p>
        </div>

        <div className="space-y-3">
          <button
            onClick={() => navigate('/auth/signup')}
            className="w-full px-6 py-3 bg-[#6E9C87] text-white rounded-lg hover:bg-#598D76 transition-colors font-medium"
          >
            Create New Account
          </button>
          
          <button
            onClick={() => navigate('/auth/signin')}
            className="w-full px-6 py-3 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors font-medium"
          >
            Sign In with Different Account
          </button>
        </div>

        <p className="text-xs text-gray-500 mt-8">
          If you have any questions or concerns, please contact support.
        </p>
      </div>
    </div>
  );
};

export default AccountDeleted;